// extracted by mini-css-extract-plugin
export default {"videoCard":"rs8Sk","controls":"vFdrI","controlButtons":"fBRHN","pin":"IOn95","addButtonTop":"jrVLW","addButtonBottom":"Sw2vH","category":"o8PSM","newsroom":"T4vN4"};